import React, { useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import IntlMessages from 'util/IntlMessages';
import { forgotPassword } from 'actions/Auth';
import { Link } from 'react-router-dom';
import { useLocalizedMessage } from 'util/useLocalizedMessage';
import AuthShell from './AuthShell';
import styles from './AuthShell.module.scss';

const SubmitNewPassword = () => {
  const localizeMessage = useLocalizedMessage();
  const dispatch = useDispatch();
  const { loader } = useSelector(({ auth }) => auth);

  const emailInputRef = useRef(null);

  const submitForgotPassword = (event) => {
    if (event) event.preventDefault();
    dispatch(forgotPassword({
      email: emailInputRef.current.value,
    }));
  };

  const basePath = window.location.href.includes('embedded') ? '/embedded' : '';

  return (
    <>
      <AuthShell
        title={localizeMessage('auth.forgot.title')}
        description={localizeMessage('auth.forgot.description')}
        loading={loader}
      >
        <form className={styles.form} onSubmit={submitForgotPassword}>
          <TextField
            id="kea-password-reset-email"
            className={styles.field}
            label={localizeMessage('appModule.email')}
            type="email"
            autoComplete="email"
            fullWidth
            required
            variant="outlined"
            inputRef={emailInputRef}
            disabled={loader}
          />
          <Button
            className={styles.primaryButton}
            type="submit"
            variant="contained"
            color="primary"
            disabled={loader}
          >
            <IntlMessages id="appModule.resetPassword" />
          </Button>
          <Link className={styles.secondaryLink} to={`${basePath}/signin`}>
            <IntlMessages id="signUp.back" />
          </Link>
        </form>
      </AuthShell>
    </>
  );
};

export default SubmitNewPassword;
